import { cssJoin } from '@volvo-cars/css/utils';
import { Icon } from '@volvo-cars/react-icons';

export interface ErrorMessageProps {
  errorMessage?: string;
  id: string;
  className?: string;
}

export function ErrorMessage({
  errorMessage,
  id,
  className = '',
}: ErrorMessageProps) {
  if (!errorMessage) return null;
  return (
    <p
      id={id}
      className={cssJoin(
        'micro text-feedback-red flex items-center',
        className,
      )}
      // This is needed because `role=alert` breaks VoiceOver in Safari
      // so we're otherwise not exposing any semantic test selectors for error messages.
      data-testid="react-forms:error-message"
    >
      <Icon
        icon="exclamation-mark-circled"
        size={12}
        className="mr-8"
        color="feedback-red"
      />
      {errorMessage}
    </p>
  );
}
